import { jsx as i } from "react/jsx-runtime";
import I from "react";
import { useEnrichTooltipOpenState as h } from "./index.es128.js";
import { SimpleTooltip as u } from "./index.es127.js";
import { Icon as _ } from "./index.es157.js";
const d = 16, g = "tooltip-icon", $ = ({
  title: o,
  testId: t = g,
  tabIndex: p = 0,
  type: l = "Info",
  color: s = "gray",
  tooltipProps: c,
  iconProps: f
}) => {
  const n = I.useRef(null), { isTooltipOpen: m, enrichTooltipProps: a } = h({ ref: n });
  let e;
  typeof o == "string" ? e = /* @__PURE__ */ i("span", { children: o }) : e = o;
  const r = {
    placement: "right",
    title: e,
    testId: `${t}-tooltip`,
    maxWidth: 300,
    ...c
  }, T = {
    testId: `${t}-icon`,
    allowHoverState: !0,
    size: d,
    tabIndex: p,
    weight: "duotone",
    ...f,
    type: l,
    color: s
  };
  return /* @__PURE__ */ i(
    u,
    {
      ...r,
      open: r.open ?? m,
      testId: `${t}-tooltip`,
      children: /* @__PURE__ */ i(_, { ref: n, ...T, ...a })
    }
  );
};
export {
  g as TOOLTIP_ICON_BASE_TEST_ID,
  $ as TooltipIcon
};
//# sourceMappingURL=index.es162.js.map
